module.exports = __webpack_public_path__ + "img/logo-foot2.7ba56249.png";